import React from "react";

interface InlineErrorProps {
  message?: string;
}

const InlineError: React.FC<InlineErrorProps> = ({
  message = "Something went wrong. Please try refreshing the page.",
}) => (
  <div className="flex flex-col items-center justify-center gap-2 py-12 text-center">
    <p className="text-sm text-midnight/60">{message}</p>
  </div>
);

export default InlineError;
